export default "__VITE_ASSET__ATuNMNef__"